import { render, staticRenderFns } from "./NotificationsVideo.vue?vue&type=template&id=4654c033&scoped=true"
import script from "./NotificationsVideo.vue?vue&type=script&lang=js"
export * from "./NotificationsVideo.vue?vue&type=script&lang=js"
import style0 from "./NotificationsVideo.vue?vue&type=style&index=0&id=4654c033&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654c033",
  null
  
)

export default component.exports